// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2qNOA","colBig":"styles_colBig__1SnAo","colSmall":"styles_colSmall__3F5EB"};